/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const dealflowDeckDtoSchema = z.object({
  slug: z.optional(z.string()),
  pageCount: z.optional(z.int()),
  captions: z.array(z.string()).nullish(),
});
